import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import * as React from "react";
import * as uuid from "uuid";
import { IPackItem, IPackItemWithId, PackItem } from "./item";

interface PackItemsProps {
    list: IPackItem[];

    onUpdate(items: IPackItem[]);
}

interface PackItemsState {
    list: IPackItemWithId[];
}

export class PackItems extends React.Component<PackItemsProps, PackItemsState> {
    state = {
        list: this.props.list.map(item => ({...item, id: uuid.v4()}))
    };

    add = () => {
        const list = [...this.state.list];

        list.push({
            id: uuid.v4(),
            itemId: 0,
            amount: 0,
            level: 0,
            premiumValue: 0
        });

        this.setState({
            list
        }, () => this.sync());
    };

    update = (item: IPackItemWithId) => {
        const list = [...this.state.list];

        const index = list.findIndex(_item => _item.id === item.id);

        list[index] = item;

        this.setState({
            list
        }, () => this.sync());
    };

    remove = (item: IPackItemWithId) => {
        const list = [...this.state.list];

        const index = list.findIndex(_item => _item.id === item.id);

        list.splice(index, 1);

        this.setState({
            list
        }, () => this.sync());
    };

    sync = () => {
        this.props.onUpdate(this.state.list.map(item => ({
            itemId: item.itemId,
            amount: item.amount,
            level: item.level,
            premiumValue: item.premiumValue
        })));
    };

    render() {
        return <Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{width: "30%"}}>Item</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Level</TableCell>
                        <TableCell>Premium Value</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.list.map(item =>
                        <PackItem key={item.id} entry={item} onRemove={this.remove} onUpdate={this.update}/>)}
                </TableBody>
            </Table>

            <Box p={3}>
                <Button disableElevation variant={"contained"} color={"primary"} onClick={this.add}>
                    Add
                </Button>
            </Box>
        </Box>;
    }
}
